import React, { useEffect, useState } from 'react';
import '../../../styles/components/MyJobsList/MyJobDetail.scss';
import { useHistory, useLocation } from 'react-router-dom';
import knowMoreBanner from '../../../assets/knowMoreBanner.png';
import MyJobCard from './MyJobCard';
import MyJobsFooter from './MyJobsFooter';
import useMoengage from '../../../hooks/useMoengage';
import MyBottomNavigation from './BottomNavigation';

function MyJobDetail() {
  const history = useHistory();
  const location = useLocation();
  const [jobDetails, setJobDetails] = useState(null);
  const trackEvent = useMoengage()[1];
  const [userId, setUserId] = useState();

  const watchVideo = () => {
    window.open('https://uploads-a.vahan.co/XyquHz-2359-fbfatx.n3f04.mp4');
    trackEvent('watch_video_click', {
      page: 'Status Details',
    });
  };

  const knowMore = () => {
    // window.open('https://uploads-a.vahan.co/XyquHz-2359-fbfatx.n3f04.mp4');
    window.open('http://shorturl.at/tAO69');
    trackEvent('know_more_click');
  };

  useEffect(() => {
    const paramString = window.location.href.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    let userIdParam;
    queryString.forEach((value, key) => {
      if (key === 'userId') userIdParam = value;
    });

    if (!userIdParam) history.replace('/status');
    else if (!location.jobDetails) history.replace(`/status?userId=${userIdParam}`);
    else {
      const jobDetailsRes = { ...location.jobDetails };
      if (jobDetailsRes && jobDetailsRes.requirements)
        jobDetailsRes.requirements = JSON.parse(jobDetailsRes.requirements);

      setJobDetails(jobDetailsRes);
      setUserId(userIdParam);
    }
  }, []);

  return jobDetails ? (
    <div className="my_job_detail">
      <div>
        <div>
          <img
            src={knowMoreBanner}
            onClick={knowMore}
            alt="logo"
            width="100%"
            id="bannerFOSReferralsDetails"
            style={{ marginLeft: '-1px' }}
          />
        </div>
        <MyJobCard {...jobDetails} viewJob={false} />
        <hr />
        <div className="extra_details">
          <div className="documents_required">
            <h5>Documents Required</h5>
            <ul>
              <li>Aadhar Card</li>
              <li>Pan Card</li>
            </ul>
          </div>
          {jobDetails.requirements && Array.isArray(jobDetails.requirements.education) && (
            <div className="requirements">
              <h5>Educational Requirements</h5>
              <ul>
                {jobDetails.requirements.education.map(el => {
                  return <li key={el}>{el}</li>;
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
      <MyJobsFooter watchVideo={watchVideo} />
      <MyBottomNavigation name="status" userId={userId} />
    </div>
  ) : null;
}

export default MyJobDetail;
